import React from 'react';

interface WalletIconProps {
  fill: string;
}

const WalletIcon = ({ fill = 'black' }: WalletIconProps) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='280' viewBox='0 0 280 234'>
      <path
        id='Icon_wallet'
        data-name='Icon wallet'
        d='M145.305,234H13.826C1.11,234,.095,223.163.086,219.8V93.541A7.385,7.385,0,0,0,0,92.7c.012-.176.054-.343.054-.518V58a25.778,25.778,0,0,0,10.585,2.272H218.1A10.955,10.955,0,0,1,229,71.285v36.775H213.385a39.283,39.283,0,0,0-38.725,41.665,39.45,39.45,0,0,0,39.66,36.489H229v36.518A11.208,11.208,0,0,1,217.853,234Zm45.746-84.848c-.841-12.95,8.736-24.143,21.4-25,.5-.035,1.006-.053,1.513-.053l35.923-.1A2.14,2.14,0,0,1,252,126.164V168.83a2.14,2.14,0,0,1-2.116,2.164H215.019q-.259.006-.517.006A23.773,23.773,0,0,1,191.051,149.152ZM261.6,63a5.5,5.5,0,1,1,0-11h12.8a5.5,5.5,0,1,1,0,11ZM163.06,44H10.656a9.946,9.946,0,0,1,0-19.883L174.451,24A7.662,7.662,0,0,1,182,31.771V44Zm83.55-9.69a6,6,0,0,1,0-8.176l8.994-9.441a5.318,5.318,0,0,1,7.782,0,5.979,5.979,0,0,1,0,8.172l-8.994,9.445a5.324,5.324,0,0,1-7.782,0ZM218,18.4V5.6a5.5,5.5,0,1,1,11,0V18.4a5.5,5.5,0,1,1-11,0Z'
        fill={fill}
      />
    </svg>
  );
};

export default WalletIcon;
